export const deleteCheckpointApi = ( apiInstance: API.Client ) => (uid: string) => (
  apiInstance.Entity.collection( 'checkpoint' ).delete( uid )
);
